import {Component, inject, Input, OnChanges} from '@angular/core';
import {OperationStepInformation} from '../../core/definitions/operation-step-information';
import {OperationService} from '../operation.service';
import {OperationContainer} from '../../core/definitions/operation-container';

@Component({
    selector: 'app-operation-view-information',
    templateUrl: './operation-view-information.component.html',
    styleUrls: ['./operation-view-information.component.scss'],
    standalone: false
})
export class OperationViewInformationComponent implements OnChanges {
  // Injections
  private readonly operationService: OperationService = inject(OperationService);

  @Input() operationContainer: OperationContainer;
  @Input() operationStepIndex: number;

  information: OperationStepInformation;

  ngOnChanges(): void {
    const stepIndex = this.operationContainer.currentOperation.$$currentStepIndex;
    let currentStep = this.operationContainer.currentOperation.operation_steps[stepIndex];
    if (!currentStep) {
      currentStep = this.operationContainer.currentOperation.copy_step;
    }
    if (!currentStep) {
      this.information = null;
      return;
    }
    if (currentStep.information) {
      this.information = currentStep.information;
      if (!this.operationContainer.currentOperation.$$currentStep) {
        this.operationService.setOperationStep(this.operationContainer).then();
      }
    }
  }

}
